import { lighten } from 'polished';
import styled from 'styled-components';

export interface IScrollProps extends React.HTMLAttributes<HTMLDivElement> {
  overflowing?: boolean;
  column?: boolean;
  'scroll-auto'?: boolean;
}

export const ScrollStyle = styled.div<IScrollProps>`
  flex: 1;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: ${(props) => (props.column ? 'column' : 'row')};
  position: relative; /* se tiver mutio conteúdo não crie scroll na página */
  gap: ${({ theme }) => theme.metrics.gap};
  padding-right: ${({ theme, overflowing }) => (overflowing ? theme.metrics.padding : 0)};
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
  overflow-y: ${(props) => (props['scroll-auto'] || !props.overflowing ? 'auto' : 'scroll')};
  overflow-x: ${(props) => (props.column ? 'hidden' : 'auto')};

  ::-webkit-scrollbar {
    width: 12px;
  }

  ::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.colors.background};
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.primary};
    border-radius: ${({ theme }) => theme.metrics.innerRadius};
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: ${({ theme }) => lighten(0.05, theme.colors.primary)};
  }

  ::-webkit-scrollbar-button {
    height: 15px;
    background-color: ${({ theme }) => lighten(0.025, theme.colors.background)};
    cursor: pointer;

    &:hover {
      background-color: ${({ theme }) => lighten(0.1, theme.colors.background)};
    }
  }

  // border radius vertical top
  ::-webkit-scrollbar-button:vertical:start {
    border-radius: ${({ theme }) =>
      `${theme.metrics.innerRadius} ${theme.metrics.innerRadius} 0 0`};
    border-bottom: 3px solid ${({ theme }) => theme.colors.background};
  }

  // border radius vertical bottom
  ::-webkit-scrollbar-button:vertical:end {
    border-radius: ${({ theme }) =>
      `0 0 ${theme.metrics.innerRadius} ${theme.metrics.innerRadius}`};
    border-top: 3px solid ${({ theme }) => theme.colors.background};
  }

  // border radius horizontal left
  ::-webkit-scrollbar-button:horizontal:start {
    border-radius: ${({ theme }) =>
      `${theme.metrics.innerRadius} 0 0 ${theme.metrics.innerRadius}`};
    border-right: 3px solid ${({ theme }) => theme.colors.background};
  }

  // border radius horizontal right
  ::-webkit-scrollbar-button:horizontal:end {
    border-radius: ${({ theme }) =>
      `0 ${theme.metrics.innerRadius} ${theme.metrics.innerRadius} 0`};
    border-left: 3px solid ${({ theme }) => theme.colors.background};
  }

  // fix double button
  ::-webkit-scrollbar-button:vertical:start:increment,
  ::-webkit-scrollbar-button:vertical:end:decrement,
  ::-webkit-scrollbar-button:horizontal:start:increment,
  ::-webkit-scrollbar-button:horizontal:end:decrement {
    display: none;
  }

  // fix resizer white
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
`;
